import { createWebComponent } from '../utils/createWebComponent';

export const UIButton = createWebComponent<HTMLElement>('ui-button');
export const UIInput = createWebComponent<HTMLElement>('ui-input');
export const UICard = createWebComponent<HTMLElement>('ui-card');
export const UIBadge = createWebComponent<HTMLElement>('ui-badge');
export const UITextarea = createWebComponent<HTMLElement>('ui-textarea');
export const UIDialog = createWebComponent<HTMLElement>('ui-dialog');
export const UIAlert = createWebComponent<HTMLElement>('ui-alert');
export const UILoading = createWebComponent<HTMLElement>('ui-loading');
export const UIMessage = createWebComponent<HTMLElement>('ui-message');
